import { NotionalType } from 'models/common/notional';
import type { Custodian } from 'models/custodian';
import { DealSplitGridMetadata } from 'models/forms/fields';
import { DealSplitReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import { connect } from 'react-redux';
import { getFieldsMetadata } from 'state/forms/metadata/selectors';
import type { AppState } from 'state/state.model';
import { getWorkspaceActiveTabId } from 'state/workspaces/workspaces/workspaces.selector';

export interface OwnProps {
  node: DealSplitReadonlyValueDefinition;
}

interface StateProps {
  availableCustodian: Custodian[];
}

export interface DealSplitHeader {
  id: string;
  type: string;
  isHidden: boolean;
  unitId: NotionalType;
}

export type ProductSummaryDealSplitProps = OwnProps & StateProps;

const EMPTY_CUSTODIANS: Custodian[] = [];
const mapStateTpProps = (state: AppState): StateProps => {
  const currentTabId = getWorkspaceActiveTabId(state, 'static')!;

  const dealSplit = getFieldsMetadata(state, 'static', currentTabId)?.DealSplit as DealSplitGridMetadata | undefined;

  const availableCustodian = dealSplit?.availableCustodians ?? EMPTY_CUSTODIANS;

  return {
    availableCustodian,
  };
};

export const connectProductSummaryDealSplit = connect(mapStateTpProps);
